export function RetroNoteSkeleton() {
  return (
    <div className="pixel-border bg-card/60 animate-pulse">
      <div className="flex items-center justify-between border-b-2 border-primary/70 bg-black/60 px-3 py-1.5">
        <div className="font-pixel text-[10px] text-neon-cyan/60">LOADING…</div>
        <div className="font-pixel text-[10px] text-neon-amber/50">T-???</div>
      </div>
      <div className="p-4 md:p-5 space-y-3">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 pixel-border-cyan bg-black/80" />
          <div className="flex-1 space-y-2">
            <div className="h-3 w-1/3 bg-primary/40" />
            <div className="h-2 w-2/3 bg-muted/50" />
          </div>
        </div>
        <div className="space-y-2">
          <div className="h-3 w-full bg-muted/40" />
          <div className="h-3 w-5/6 bg-muted/40" />
          <div className="h-3 w-3/4 bg-muted/40" />
        </div>
      </div>
    </div>
  );
}
